import React, { useEffect, useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import axios from 'axiosInstance'
import 'react-big-calendar/lib/css/react-big-calendar.css'

const localizer = momentLocalizer(moment)

export default function MiCalendario() {
  const [eventos, setEventos] = useState([])
  const [date, setDate] = useState(new Date())
  const [view, setView] = useState('month')
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null)

  useEffect(() => {
    axios.get(process.env.REACT_APP_BACKEND_URL + '/api/eventos')
      .then(response => {
        const mapped = response.data.map(ev => ({
          id: ev.id,
          title: ev.nombre,
          start: new Date(ev.fecha_inicio),
          end:   new Date(ev.fecha_fin),
          tipo:  ev.tipo,
          estado: ev.estado
        }))
        setEventos(mapped)
      })
      .catch(err => console.error('Error al cargar eventos', err))
  }, [])

  
  const cerrarModal = () => setEventoSeleccionado(null)

  return (
    <div style={{ height: '700px', padding: '20px' }}>
      <Calendar
        localizer={localizer}
        events={eventos}
        startAccessor="start"
        endAccessor="end"
        titleAccessor="title"
        style={{ height: '100%', width: '70%', margin: '0 auto' }}
        views={['month', 'week', 'day']}
        toolbar={true}
        popup={true}
        view={view}
        onView={setView}
        date={date}
        onNavigate={setDate}
        onSelectEvent={event => setEventoSeleccionado(event)} 
      />

      {eventoSeleccionado && (
  <div style={{
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  }}>
    <div style={{
      background: 'white',
      padding: 20,
      borderRadius: 8,
      minWidth: 300,
      maxWidth: '90%'
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#184682',
        marginBottom: '1rem'
      }}>
        {eventoSeleccionado.title}
      </h2>
      <p style={{ color: '#0056b3', margin: '0.5rem 0' }}>
        <strong>Inicio:</strong> {eventoSeleccionado.start.toLocaleString()}
      </p>
      <p style={{ color: '#0056b3', margin: '0.5rem 0' }}>
        <strong>Fin:</strong> {eventoSeleccionado.end.toLocaleString()}
      </p>
      <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
        <button
          onClick={cerrarModal}
          style={{
            width: 100,
            padding: '0.5rem 1rem',
            color: '#0056b3',
            border: '2px solid #0056b3',
            borderRadius: 4,
            background: 'white',
            cursor: 'pointer'
          }}
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  )
}
